<script setup>
useHead({
  title: "Error | Oops ..",
});
const error = useError();
</script>
<template>
  <NuxtLayout>
    <main class="grow">
      <div class="absolute inset-0 max-w-6xl mx-auto px-4 sm:px-6">
        <Particles class="hidden dark:block absolute inset-0" />
      </div>
      <div class="relative py-32 md:py-40 mx-auto text-center z-10">
        <template v-if="error.statusCode === 404">
          <h1>You are lost in space</h1>
          <img src="/images/space404.svg" alt="" aria-hidden="true" class="block mx-auto mb-10" />
          <p>Sorry, that page doesn't exist.</p>
        </template>
        <template v-else>
          <h1>Dang</h1>
          <img src="/images/space404.svg" alt="" aria-hidden="true" class="block mx-auto mb-10" />
          <p>
            <strong>{{ error }}</strong>
          </p>
          <p>It looks like something broke.</p>
          <p>Sorry about that.</p>
        </template>
        <p>
          Go back to your
          <nuxt-link to="/" class="cursor-pointer text-green-600 hover:text-green-500">
            home.
          </nuxt-link>
        </p>
      </div>
    </main>
  </NuxtLayout>
</template>
<style scoped>
h1 {
  @apply text-5xl font-bold text-slate-900 dark:text-white;
}
p {
  @apply text-xl text-gray-800 dark:text-slate-50;
}
</style>
